import { render, staticRenderFns } from "./OVDetailCotizacionYBoletas.vue?vue&type=template&id=2ca761f7&scoped=true&lang=pug"
import script from "./OVDetailCotizacionYBoletas.vue?vue&type=script&lang=js"
export * from "./OVDetailCotizacionYBoletas.vue?vue&type=script&lang=js"
import style0 from "./OVDetailCotizacionYBoletas.vue?vue&type=style&index=0&id=2ca761f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca761f7",
  null
  
)

export default component.exports